import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyC8IKdkRdZmguN74VcL1kcBcHRhzcXo6wY",
  authDomain: "campuspulse-cc37e.firebaseapp.com",
  projectId: "campuspulse-cc37e",
  storageBucket: "campuspulse-cc37e.firebasestorage.app",
  messagingSenderId: "623388155860",
  appId: "1:623388155860:web:2aaa9cc972a307af3cc041",
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);
